var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExploreFeelingLucky(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Explore",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/iconQuestion",
    style: {
      mixBlendMode: "overlay"
    },
    fill: "#FFFFFF"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "question-circle",
    transform: "translate(74.666667, 74.666667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.333333,0 C281.473935,0 362.666667,81.2219785 362.666667,181.333333 C362.666667,281.503183 281.473935,362.666667 181.333333,362.666667 C81.1927312,362.666667 0,281.503183 0,181.333333 C0,81.2219785 81.1927312,0 181.333333,0 Z M181.333333,245.333333 C163.688116,245.333333 149.333333,259.688116 149.333333,277.333333 C149.333333,294.977855 163.688116,309.333333 181.333333,309.333333 C198.978551,309.333333 213.333333,294.977855 213.333333,277.333333 C213.333333,259.688116 198.978551,245.333333 181.333333,245.333333 Z M182.077868,64 C142.518989,64 117.288471,80.5455856 97.476003,109.951712 C94.9092526,113.761441 95.7679816,118.899459 99.446797,121.669189 L124.634487,140.631351 C128.41275,143.476036 133.795957,142.799279 136.73146,139.101982 C149.698776,122.771892 158.590214,113.302342 178.327189,113.302342 C193.156416,113.302342 211.498954,122.778378 211.498954,137.055856 C211.498954,147.849369 202.524764,153.392432 187.882818,161.543063 C170.806959,171.047207 148.211425,182.876396 148.211425,212.468468 L148.211425,215.351351 C148.211425,220.127568 152.111637,224 156.922117,224 L197.57201,224 C202.38249,224 206.282702,220.127568 206.282702,215.351351 L206.282702,214.390631 C206.282702,193.877477 266.666667,193.023423 266.666667,137.513514 C266.666667,95.7102703 222.993437,64 182.077868,64 Z",
    id: "Combined-Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExploreFeelingLucky);
export default __webpack_public_path__ + "static/media/iconExploreFeelingLucky.fafba242.svg";
export { ForwardRef as ReactComponent };